import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import React from 'react';

import Navigation from './Navigation';
import Separator from './Separator';

const StyledFooter = styled('footer')(({ theme }) => ({
  position: 'relative',
  background: theme.palette.background.footerGradient,
  marginTop: 'auto',
  width: '100%',
  padding: theme.spacing(4),
  paddingTop: 100,
  '.navigation': {
    justifyContent: 'center',
    alignItems: 'center',
    '.home': {
      lineHeight: 1,
    },
  },
  '.MuiContainer-root': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const Address = styled('address')(({ theme }) => ({
  fontSize: '0.8rem',
  textAlign: 'center',
  marginTop: theme.spacing(2),
}));

const Copyright = styled('p')({
  fontSize: '0.8rem',
  textAlign: 'center',
});

const Footer = () => {
  return (
    <StyledFooter>
      <Separator fill="brand" />
      <Container>
        <Navigation />
        <Address>Adolfsallee 18 | 65185 Wiesbaden</Address>
        <Copyright>© {new Date().getFullYear()} mk mediaconcept GbR</Copyright>
      </Container>
    </StyledFooter>
  );
};

export default Footer;